import React, { Component } from 'react';
import {
    Container,
    Col,
    Row,
    Button,
    Table,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Input,
    Modal,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { Search } from '../Search';

/**
 * Used for the Listino Prezzi section. 
 */
export class AddDeposito extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.toggleErrorModal = this.toggleErrorModal.bind(this);

        this.state = {
            dropdownOpen: false,
            errorModal: false,
            KG: 'KG',
            PZ: 'PZ',
            articolo: {}
        };

    }

    componentDidMount() {
        this.props.handleArticoloselected();
    }

    toggle() {
        if (this.state.dropdownOpen) {
            this.setState({
                dropdownOpen: !this.state.dropdownOpen,
                umHeight: 'auto',
            });
        }
        else {
            this.setState({
                dropdownOpen: !this.state.dropdownOpen,
                umHeight: '30vh',
            });
        }
    }

    toggleErrorModal = () => {
        this.setState({
            errorModal: !this.state.errorModal
        })
    }

    handleInserisciClick = () => {
        if (this.props.selectedUm === 'Seleziona UM') {
            this.toggleErrorModal();
        }
        else {
            this.props.handleInserisciClick();
        }
    }

    /**
     * Renders the page
     */
    render() {

        const titolo = (
            <h5 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>Aggiungi un Articolo</h5>
        );

        return (
            <Container fluid style={{ minHeight: '75vh' }}>
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                        <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>
                            {titolo}
                        </Col>
                    </Row>
                </Container>                
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                        <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>
                            {this.props.articolo.descrizione}
                        </Col>
                    </Row>
                </Container>
                {this.props.articolo && this.props.articolo.articoloId ?
                    <div>
                        <Container className="d-flex align-items-center" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                                <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                    <Table responsive borderless style={{ width: "100%", margin: "0", marginTop: "5px" }}>
                                        <tbody style={{ fontSize: "20px" }}>
                                            <tr>
                                                <th style={{ width: "25%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Um:  </th>
                                                <td align="left" style={{ padding: "0", height: `${this.state.umHeight}` }}>
                                                    <div>
                                                        <Dropdown style={{ width: '40%', textAlign: 'center' }} isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                                                            <DropdownToggle style={{ width: '100%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} caret>
                                                                {this.props.selectedUm}
                                                            </DropdownToggle>
                                                            <DropdownMenu
                                                                modifiers={{
                                                                    setMaxHeight: {
                                                                        enabled: true,
                                                                        order: 890,
                                                                        fn: (data) => {
                                                                            return {
                                                                                ...data,
                                                                                styles: {
                                                                                    ...data.styles,
                                                                                    overflow: 'auto',
                                                                                    maxHeight: "50vh",
                                                                                },
                                                                            };
                                                                        },
                                                                    },
                                                                    computeStyle: {
                                                                        gpuAcceleration: false
                                                                    }
                                                                }}>
                                                                {this.props.prezzo.um == 'KG' ?
                                                                    <div>
                                                                        <DropdownItem id={'KG'} onClick={() => this.props.handleArticoloUmSelected(this.state.KG)} style={{ color: "#011e41" }}>
                                                                            KG
                                                                        </DropdownItem>
                                                                        <DropdownItem id={'PZ'} onClick={() => this.props.handleArticoloUmSelected(this.state.PZ)} style={{ color: "#011e41" }}>
                                                                            PZ
                                                                        </DropdownItem>
                                                                    </div>
                                                                    :
                                                                    <DropdownItem id={'PZ'} onClick={() => this.props.handleArticoloUmSelected(this.state.PZ)} style={{ color: "#011e41" }}>
                                                                        PZ
                                                                    </DropdownItem>}
                                                            </DropdownMenu>
                                                        </Dropdown>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Container>
                        <Container className="d-flex align-items-center" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                                <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                    <Table responsive borderless style={{ width: "100%", margin: "0", marginTop: "5px" }}>
                                        <tbody style={{ fontSize: "20px" }}>
                                            <tr>
                                                <th style={{ width: "25%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Quantita:  </th>
                                                <td align="left" style={{ padding: "0" }}>
                                                    <div>
                                                        <Button onClick={() => this.props.handleArticoloQuantitaChange(-1)} style={{ padding: "0px", width: "3vw", marginRight: "10px", borderWidth: "medium", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", fontSize: "20px", verticalAlign: "middle", textAlign: "center", fontWeight: "bold" }}>-</Button>
                                                        {this.props.quantita}
                                                        <Button onClick={() => this.props.handleArticoloQuantitaChange(1)} style={{ padding: "0px", width: "3vw", marginLeft: "10px", borderWidth: "medium", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", fontSize: "20px", verticalAlign: "middle", textAlign: "center", fontWeight: "bold" }}>+</Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Container>
                        <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                            <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                <Table responsive borderless style={{ width: "100%", margin: "0", marginTop: "5px" }}>
                                    <tbody style={{ fontSize: "20px" }}>
                                        <tr>
                                            <th style={{ width: "25%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Peso Medio:  </th>
                                            <td align="left" style={{ padding: "0" }}>
                                                {this.props.articolo.pesoMedio}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        </Container>
                        <Container className="d-flex align-items-center" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                                <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                    <Button type="button" className="text-center" onClick={this.handleInserisciClick} style={{ width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }}>
                                        Inserisci riga
                                        </Button>
                                </Col>
                            </Row>
                        </Container>
                    </div> : null
                }
                <Modal isOpen={this.state.errorModal} toggle={this.toggleErrorModal} style={{ color: "#011e41" }}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            Controllare l'unità di misura
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{ width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={() => this.setState({ errorModal: false })}>
                                Ok
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
            </Container>
        )
    }
}

/*<Container className="d-flex align-items-center" fluid>
<Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
    <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
        <Table responsive borderless style={{ width: "100%", margin: "0", marginTop: "5px" }}>
            <tbody style={{ fontSize: "20px" }}>
                <tr>
                    <th style={{ width: "25%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Prezzo:  </th>
                    <td align="left" style={{ padding: "0" }}>
                        <div>
                            {this.props.prezzo.um !== 'NR' ?
                                <div>€{this.props.prezzo.prezzo} / {this.props.prezzo.um}</div> :
                                <div>€{this.props.prezzo.prezzo}</div>
                            }
                        </div>
                    </td>
                </tr>
            </tbody>
        </Table>
    </Col>
</Row>
</Container>

<Container className="d-flex align-items-center" fluid>
<Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
    <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
        <Table responsive borderless style={{ width: "100%", margin: "0", marginTop: "5px" }}>
            <tbody style={{ fontSize: "20px" }}>
                <tr>
                    <th style={{ width: "25%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Stima:  </th>
                    <td align="left" style={{ padding: "0" }}>
                        € {this.props.stima.toFixed(2)}
                    </td>
                </tr>
            </tbody>
        </Table>
    </Col>
</Row>
</Container>
<div>
{this.props.prezzo.maxSconto1 > 0 ?
    <Container className="d-flex align-items-center" fluid>
        <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
            <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                <Table responsive borderless style={{ width: "100%", margin: "0", marginTop: "5px" }}>
                    <tbody style={{ fontSize: "20px" }}>
                        <tr>
                            <th style={{ width: "25%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Sconto 1:  </th>
                            <td align="left" style={{ padding: "0" }}>
                                <div onLoad={() => this.props.handleSconto1Change()}>
                                    {this.props.prezzo.maxSconto1}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Col>
        </Row>
    </Container> : null
}
</div>
<div>
{this.props.prezzo.maxSconto2 > 0 ?
    <Container className="d-flex align-items-center" fluid>
        <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
            <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                <Table responsive borderless style={{ width: "100%", margin: "0", marginTop: "5px" }}>
                    <tbody style={{ fontSize: "20px" }}>
                        <tr>
                            <th style={{ width: "25%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Sconto 2:  </th>
                            <td align="left" style={{ padding: "0" }}>
                                <div>
                                    {this.props.sconto2}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Col>
        </Row>
    </Container> : null
}
</div>
<Container className="d-flex align-items-center" fluid>
<Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
    <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
        <Table responsive borderless style={{ width: "100%", margin: "0", marginTop: "5px" }}>
            <tbody style={{ fontSize: "20px" }}>
                <tr>
                    <th style={{ width: "12.5%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Note:  </th>
                    <td align="left" style={{ padding: "5px", height: `15vh` }}>
                        <Input type="textarea" name="note" id="note" style={{ height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px" }} onChange={this.props.handleNoteChange} value={this.props.note} />
                    </td>
                </tr>
            </tbody>
        </Table>
    </Col>
</Row>
</Container>*/


// WEBPACK FOOTER //
// ./src/components/NuovoOrdine/AddDeposito.js